import React, { useState, memo, useEffect } from "react";
import { Badge, RadioButton, Toast } from "@shopify/polaris";
import {
  reqGetOrderNewShipping,
  reqPostOrderNewShippingUpdate,
} from "../../../../api";
import { useGetState } from "ahooks";
import intl from "../../../../i18n/intl";
import ShopifyModal from "../../../../components/ShopifyModal";

const ShippingMethodsModal = memo(
  ({
    orderId,
    open,
    setIsShowShippingMethodsModal,
    requestParams,
    getPageData,
    orderPayStatus
  }) => {
    const [buttonLoading, setButtonLoading] = useState(false); //按钮加载
    const [shippingData, setShippingData, getShippingData] = useGetState([]);
    const handleShippingRadioChange = (key) => {
      if (orderPayStatus !== '' && (orderPayStatus === 'Pending' || orderPayStatus === 'Paid' || orderPayStatus === 'Refund' || orderPayStatus === 'Partially refund')) {
        return
      }
      // 单选按钮点击事件
      const result = shippingData.map((item, index) => {
        if (index+'-1' === key) {
          return { ...item, selected: 1 };
        } else {
          return { ...item, selected: 0 };
        }
      });
      setShippingData(result);
    };
    // 关闭
    const handleOff = () => {
      setIsShowShippingMethodsModal();
      setShippingData([]);
    };
    const handleDoneChange = () => {
      //确认请求
      const data = getShippingData();
      // const id = data.filter(item => item.selected === 1)[0].id
      postUpdateOrderShippingMethods(data);
    };
    useEffect(() => {
      let isMount = true;
      if (open && isMount) {
        getData();
      }
      return () => (isMount = false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]); //数据初始化

    const getData = () => {
      initData(orderId);
    };

    const initData = async (orderId) => {
      let res = await reqGetOrderNewShipping({ id: orderId });
      if (res.code === "200") {
        setShippingData(res.data);
      }
    }; //接口请求
    // 保存
    const postUpdateOrderShippingMethods = async (data) => {
      let params = {
        id: orderId,
        shipping_result: data,
      };
      setButtonLoading(true);
      try {
        let res = await reqPostOrderNewShippingUpdate(params);
        if (res.code === "200") {
          setButtonLoading(false);
          getPageData(requestParams);
          handleOff();
          toggleToast('Saved successfully')
        } else {
          setTimeout(() => {
            setButtonLoading(false);
          }, 1000);
        }
      } catch (error) {}
    };

    const emptyContentNode = (
      <>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img
            src="/empty.svg"
            alt=""
            style={{ weight: "236px", height: "236px" }}
          />
        </div>
        <p style={{ textAlign: "center", margin: "20px 0", fontSize: "15px" }}>
        No supported shipping method,<br /> please contact your dedicated manager
          for a consultation.
        </p>
      </>
    );

    const shippingContentNode = (
      <>
        <table style={{ width: "100%",borderCollapse: 'collapse' }}>
          <thead
            style={{ borderBottom: "1px solid #D8D8D8", tableLayout: "fixed" }}
          >
            <tr>
            <th align="left" style={{ width: "40%", padding: "8px" }}>
            {intl.get("Shipping Method")}
            </th>
           
            <th align="left" style={{ width: "30%", padding: "8px" }}>
            {intl.get("Shipping Cost")}
            </th>
            <th align="left" style={{ width: "30%", padding: "8px" }}>
            {intl.get("Estimated Delivery Time")}
            </th>
            </tr>
          </thead>
          <tbody
            style={{ maxHeight: "200px", overflowY: "auto", width: "100%" }}
          >
            {shippingData.length > 0 &&
              shippingData.map((item, key) => {
                return (
                  <tr style={{ borderBottom: "1px solid #D8D8D8" }} key={key}>
                    <td
                      align="left"
                      style={{ width: "40%", padding: "8px" ,borderBottom: "1px solid #D8D8D8"}}
                    >
                      <RadioButton
                        label={item.ShippingMethod}
                        id={key+'-1'}
                        name="shipping methods"
                        checked={item.selected === 1}
                        disabled={orderPayStatus !== '' && (orderPayStatus === 'Pending' || orderPayStatus === 'Paid' || orderPayStatus === 'Refund' || orderPayStatus === 'Partially refund')}
                        onChange={() => {
                          handleShippingRadioChange(key+'-1')
                        }}
                      />
                    </td>
                    <td
                      align="left"
                      style={{ width: "30%", padding: "8px" ,borderBottom: "1px solid #D8D8D8"}}
                    >
                      US${item.BeforeConvertCost} {item.currency_code}
                    </td>
                    <td
                      align="left"
                      style={{ width: "30%", padding: "8px",borderBottom: "1px solid #D8D8D8" }}
                    >
                      <Badge tone="info">{item.DeliveryTime}</Badge>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </>
    );
    const [showToast, setShowToast] = useState(false);
    const [showToastText, setShowToastText] = useState("");
    const [showToastIserror, setShowToastIserror] = useState(false);
    //提示弹窗
    const toggleToast = (showToastText, showToastIserror = false) => {
      setShowToast(showToastText !== "");
      setShowToastText(showToastText);
      setShowToastIserror(showToastIserror);
    };
    const toastMarkup = showToast ? (
      <Toast
        content={showToastText}
        onDismiss={() => toggleToast("")}
        error={showToastIserror}
      />
    ) : null;
    return (
      <div>
        <ShopifyModal
          id="shipping-methods-modal"
          open={open}
          onClose={() => handleOff()}
          heading={intl.get("Shipping Methods")}
          primaryAction={
            shippingData.length > 0 && {
              content: intl.get("Done"),
              onAction: handleDoneChange,
              loading: buttonLoading,
              disabled:orderPayStatus !== '' && (orderPayStatus === 'Pending' || orderPayStatus === 'Paid' || orderPayStatus === 'Refund' || orderPayStatus === 'Partially refund')
            }
          }
          secondaryActions={
            [
              {
                content: intl.get("Close"),
                onAction: () => handleOff(),
              },
            ]
          }
        >
            {shippingData.length > 0 ? shippingContentNode : emptyContentNode}
        </ShopifyModal>
        {toastMarkup}
      </div>
    );
  }
);

export default ShippingMethodsModal;
